import script from "./NavLink.vue?vue&type=script&setup=true&lang=js"
export * from "./NavLink.vue?vue&type=script&setup=true&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=2975f81c&lang=scss"

const __exports__ = script;

export default __exports__